/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(8 9)" _stroke="#00272E"><circle pid="0" cx="5.833" cy="5.833" r="5.833"/><path pid="1" d="M15.31 15.31L10 10"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/search.js